export const TOGGLE_FOLDER_ADD_MODAL = "app/MODAL/TOGGLE_FOLDER_ADD_MODAL";
export const TOGGLE_FOLDER_UPLOAD_MODAL =
  "app/MODAL/TOGGLE_FOLDER_UPLOAD_MODAL";
export const TOGGLE_FILE_INFO_MODAL = "app/MODAL/TOGGLE_FILE_INFO_MODAL";
export const TOGGLE_DELETE = "app/MODAL/TOGGLE_DELETE";

export const TOGGLE_FILE_VALID_MODAL = "app/MODAL/TOGGLE_FILE_VALID_MODAL";

export const TOGGLE_STEP_DELETE = "app/MODAL/TOGGLE_STEP_DELETE";
export const TOGGLE_FIELD_DELETE = "app/MODAL/TOGGLE_FIELD_DELETE";

export const TOGGLE_CONFIRM_MODAL = "app/MODAL/TOGGLE_CONFIRM_MODAL";

export const TOGGLE_HISTORY_MODAL = "app/MODAL/TOGGLE_HISTORY_MODAL";

export const TOGGLE_ASSESSMENT_TOOL_MODAL =
  "app/MODAL/TOGGLE_ASSESSMENT_TOOL_MODAL";

export const TOGGLE_BODY_MAP_MODAL = "app/MODAL/TOGGLE_BODY_MAP_MODAL";
export const TOGGLE_BODY_MAP_OVERVIEW_MODAL =
  "app/MODAL/TOGGLE_BODY_MAP_OVERVIEW_MODAL";

export const TOGGLE_TOOLSNAPSHOT_MODAL = "app/MODAL/TOGGLE_TOOLSNAPSHOT_MODAL";

export const TOGGLE_VERSION_REVIEW_MODAL =
  "app/MODAL/TOGGLE_VERSION_REVIEW_MODAL";

export const TOGGLE_WARNING_MODAL = "app/MODAL/TOGGLE_WARNING_MODAL";

export const TOGGLE_PRE_STATUS_MODAL = "app/MODAL/TOGGLE_PRE_STATUS_MODAL";

export const TOGGLE_CONVERT_RESIDENT_MODAL =
  "app/MODAL/TOGGLE_CONVERT_RESIDENT_MODAL";

export const TOGGLE_RESIDENT_STATUS_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_STATUS_MODAL";

export const TOGGLE_RESIDENT_SCHEDULE_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_SCHEDULE_MODAL";

export const TOGGLE_RESIDENT_MEDICATION_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_MEDICATION_MODAL";

export const TOGGLE_RESIDENT_APPOINTMENT_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_APPOINTMENT_MODAL";

export const TOGGLE_DRAFT_CONFIRMATION_MODAL =
  "app/MODAL/TOGGLE_DRAFT_CONFIRMATION_MODAL";

export const TOGGLE_RESIDENT_GOVERNANCE_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_GOVERNANCE_MODAL";

export const TOGGLE_BODY_MAP_PREVIEW_MODAL =
  "app/MODAL/TOGGLE_BODY_MAP_PREVIEW_MODAL";

export const TOGGLE_TOOL_PREVIEW_MODAL = "app/MODAL/TOGGLE_TOOL_PREVIEW_MODAL";
export const TOGGLE_OBSERVATION_MODAL = "app/MODAL/TOGGLE_OBSERVATION_MODAL";
export const TOGGLE_OBSERVATION_FORM_MODAL =
  "app/MODAL/TOGGLE_OBSERVATION_FORM_MODAL";

export const TOGGLE_BODY_MAP_ENTRY_MODAL =
  "app/MODAL/TOGGLE_BODY_MAP_ENTRY_MODAL";

export const TOGGLE_PRE_ASSESSMENT_DOC_MODAL =
  "app/MODAL/TOGGLE_PRE_ASSESSMENT_DOC_MODAL";

export const TOGGLE_RESIDENT_DOCUMENT_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_DOCUMENT_MODAL";

export const TOGGLE_RESIDENT_DOCUMENT_VIEW_MODAL =
  "app/MODAL/TOGGLE_RESIDENT_DOCUMENT_VIEW_MODAL";

export const TOGGLE_REVISION_VIEW_MODAL =
  "app/MODAL/TOGGLE_REVISION_VIEW_MODAL";

export const TOGGLE_PUBLISH_CONFIRMATION_MODAL =
  "app/MODAL/TOGGLE_PUBLISH_CONFIRMATION_MODAL";

export const TOGGLE_SNOOZE_MODAL = "app/MODAL/TOGGLE_SNOOZE_MODAL";

export const TOGGLE_EVIDENCE_MODAL = "app/MODAL/TOGGLE_EVIDENCE_MODAL";

export const TOGGLE_GOVERNANCE_STATUS_MODAL =
  "app/MODAL/TOGGLE_GOVERNANCE_STATUS_MODAL";

export const TOGGLE_ASSIGN_MODAL = "app/MODAL/TOGGLE_ASSIGN_MODAL";

export const TOGGLE_EVALUATION_MODAL = "app/MODAL/TOGGLE_EVALUATION_MODAL";
export const TOGGLE_CARE_PLAN_EVALUATION_MODAL =
  "app/MODAL/TOGGLE_CARE_PLAN_EVALUATION_MODAL";

export const TOGGLE_CARE_PLAN_STATUS_MODAL =
  "app/MODAL/TOGGLE_CARE_PLAN_STATUS_MODAL";

export const TOGGLE_COMPLETE_MODAL = "app/MODAL/TOGGLE_COMPLETE_MODAL";

export const TOGGLE_MONITOR_MODAL = "app/MODAL/TOGGLE_MONITOR_MODAL";

export const TOGGLE_MAINTENANCE_COMPLIANCE_ADD_MODAL =
  "app/MODAL/TOGGLE_MAINTENANCE_COMPLIANCE_ADD_MODAL";

export const TOGGLE_MAINTENANCE_INVOICE_ADD_MODAL =
  "app/MODAL/TOGGLE_MAINTENANCE_INVOICE_ADD_MODAL";

export const TOGGLE_POLICY_ACKNOWLEDGEMENT_REPORT_MODAL =
  "app/MODAL/TOGGLE_POLICY_ACKNOWLEDGEMENT_REPORT_MODAL";

export const TOGGLE_CARE_ROUND_REPORT_MODAL =
  "app/MODAL/TOGGLE_CARE_ROUND_REPORT_MODAL";

export const TOGGLE_REGISTER_MODAL = "app/MODAL/TOGGLE_REGISTER_MODAL";

export const TOGGLE_WORKSPACE_MODAL = "app/MODAL/TOGGLE_WORKSPACE_MODAL";
